import React from "react";
import LikeButton from "./Player/LikeButton";

function PlayList({ tracklist, changeTrack, currentTrack, likes, like }) {
  return (
    <>
      <div className="relative z-40 flex flex-col w-full space-y-4 md:w-1/2 md:space-y-4">
        <p className="px-4 text-slate-300">Playlist</p>
        <ul className="flex flex-col text-[12px] w-full">
          {tracklist.map((item) => {
            return (
              <li
                key={item.id}
                className={` ${currentTrack === item.id - 1 && "bg-slate-500/30"} flex items-center justify-between w-full space-x-2 py-2 px-4 rounded-lg`}
                onClick={() => changeTrack(item.id)}
              >
                <div className="flex items-center w-full space-x-2">
                  <div className="w-[40px] h-[40px] bg-green-600 rounded-full picture overflow-auto relative">
                    <img
                      src={item.picture}
                      alt=""
                      srcSet={item.picture}
                      className="w-full h-fullF"
                    />
                    {currentTrack === item.id - 1 && (
                      <div className="absolute top-0 left-0 flex items-center justify-center w-full h-full text-blue-500 bg-slate-700/80 text-[16px]">
                        <i className="bi-music-note"></i>
                      </div>
                    )}
                  </div>
                  <div className="flex flex-col">
                    <span
                      className={`${
                        currentTrack === item.id - 1
                          ? "text-blue-500"
                          : "text-slate-300"
                      } `}
                    >
                      {item.title}
                    </span>
                    <span className="text-slate-400">{item.artist}</span>
                  </div>
                </div>

                {likes[item.id - 1] === true ? (
                  <LikeButton
                    isLiked={true}
                    onClick={() => like(item.id - 1)}
                    fontSize={12}
                  />
                ) : (
                  <LikeButton
                    isLiked={false}
                    onClick={() => like(item.id - 1)}
                    fontSize={12}
                  />
                )}
              </li>
            );
          })}
        </ul>
      </div>
      <style jsx="true">{``}</style>
    </>
  );
}

export default PlayList;
